import { render, staticRenderFns } from "./TheProductDetailsCustomizationModal.vue?vue&type=template&id=636ca511&"
import script from "./TheProductDetailsCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./TheProductDetailsCustomizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636ca511')) {
      api.createRecord('636ca511', component.options)
    } else {
      api.reload('636ca511', component.options)
    }
    module.hot.accept("./TheProductDetailsCustomizationModal.vue?vue&type=template&id=636ca511&", function () {
      api.rerender('636ca511', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetailsCustomizationModal.vue"
export default component.exports